<template>
    <div class="card-table-container">
        <div style="min-width: 277px;">
            <div class="card-table-header flex height-31">
                <div class="flex-1" v-for="i in tabHead">{{ i }}</div>
            </div>
            <ul class="card-table-body" v-loading="marketPolling && loading && !list.length" element-loading-background="var(--theme-bg)">
                <li class="flex height-31" v-for="v in list"  @click="childMethod(v)">
                    <div class="flex-1 home_tab">{{ v.name }}</div>
                    <div class="flex-1 home_tab">{{ price(v.zxj) }}</div>
                    <div class="flex-1 home_tab">{{ v.lzg }}</div>
                    <div class="flex-1 home_tab" :class="quoteTone(v.zdf)">{{ percent(v.zdf) }}</div>
                    
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { quotePercent, quotePrice } from '@/utils/quoteDisplay'
import { quoteTone } from '@/utils/quoteColors'
import { boardAll } from '@/utils/requestapis'
import { marketRequest, pollMarket } from '@/utils/marketRefresh'
    export default {
        name: "CardTable",
        props: {
            marketPolling: { type: Boolean, default: false },
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                page:1,
                list:[],
                loading: false,
                loaded: false,
                refreshing: false,
                requestId: 0,
                tabHead:['热门概念','最新价','领涨股','涨跌幅'],
                chartTabIndex: 0,
                
         
            }
        },
        watch: { marketPolling(active) { if (active) this.activate(); else this.stopPolling() } },
        mounted() { if (this.marketPolling) this.activate() },
        beforeDestroy() { this.disposed = true; this.requestId++; this.stopPolling() },
        methods: {
            price: quotePrice,
    percent: quotePercent,
            quoteTone,
            stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
            async activate() {
                if (this.disposed || !this.marketPolling || this.stopRefresh) return
                try {
                    if (this.loaded) await this.refreshMarket()
                    else await this.initData()
                } catch (_) { /* Keep the previous snapshot; the next active poll can retry. */ }
                finally {
                    if (!this.disposed && this.marketPolling && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.refreshMarket(), 'cn')
                }
            },
            async refreshMarket() {
                if (this.disposed || !this.marketPolling || this.loading || this.refreshing) return
                this.refreshing = true
                try {
                    const type = this.type
                    const result = await marketRequest('cn-boards')
                    if (this.disposed || type !== this.type) return
                    const rankType = { gn: 'concept', hy2: 'plate', dy: 'area' }[type]
                    const rows = result && result.data && result.data.rank && result.data.rank[rankType]
                    if (!Array.isArray(rows)) throw new Error('板块返回异常')
                    this.list = rows.map(item => ({
                        code: item.bd_code,
                        name: item.bd_name,
                        zxj: item.nzg_zxj,
                        lzg: item.nzg_name,
                        zdf: item.bd_zdf
                    }))
                } finally { this.refreshing = false }
            },
            childMethod(v) {
                this.$nextTick(() => {
                    this.$emit('card-table-click', v)
                });
            },
            async initData(){
                if (this.disposed || !this.marketPolling || this.loading) return
                let data = {
                    type:this.type,
                    page:this.page
                };
                this.list = []
                const requestId = ++this.requestId
                this.loading = true
                try {
                    const res = await boardAll(data)
                    if (this.disposed || requestId !== this.requestId) return
                    if (!res || !Array.isArray(res.lists)) throw new Error('板块返回异常')
                    this.list = res.lists
                    this.loaded = true
                } finally { if (requestId === this.requestId) this.loading = false }
            },
          changeClass(idx){
      return 'flex-1 ' + quoteTone(idx)
          }
        }
    }
</script>

<style lang="scss" scoped>
    .card-table-container {
        height: 100%;
        overflow: auto;
        color: var(--theme-label);
		cursor: pointer;
        &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: #eee;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #c1c1c1;
            ///border-radius: 8px;

            &:hover {
                background-color: #a8a8a8;
            }

            &:active {
                background-color: #787878;
            }
        }

        & {
           // border-radius: 8px;
            scrollbar-width: thin;
            scrollbar-color: #c1c1c1 #eee;
        }
    }
    .home_tab{
        overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
    }
    .height-31 {
        height: 31px;
        line-height: 31px;
    }

    .card-table-header,.card-table-body {
        padding: 0 11px;
    }
    .card-table-body {
        overflow-y: auto;
    }
    // .card-table-header div:nth-child(1) {
    //     // width: 180px;
    //     width: 120px;
    //     border: 1px solid red;
    // }
    // .card-table-header div:nth-child(2) {
    //     // width: 180px;
    //     width: 100px;
    //     border: 1px solid red;
    // }
    // .card-table-header div:nth-child(3) {
    //     // width: 180px;
    //     width: 100px;
    //     border: 1px solid red;
    // }
    // .card-table-body li div:nth-child(1) {
    //     min-width: 120px;
    // }
    // .card-table-body li div:nth-child(2) {
    //     min-width: 80px;
    // }
    // .card-table-body li div:nth-child(3) {
    //     min-width: 80px;
    // }
    .home_zs_box{
        width: 120px;
        text-align: center;
    }
    .home_zs_active{
        color: var(--theme-text);
        //border-bottom: 2px solid var(--theme-text) !important;
    }
</style>
